import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import AuthRUService from '../../../services/Auth/AuthRUService';
import { toast } from 'react-toastify';
import { Loading } from '../../../components';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const loginSession = urlParams.get("login_session");
        const code = urlParams.get("code");
        const state = urlParams.get("state");

        // CASO SESSÃO UNIFICADA (Login Direto)
        if (loginSession) {
            AuthRUService.finalizarLoginComSessao(loginSession).then(success => {
                if (success) {
                    navigate("/", { replace: true });
                } else {
                    toast.error('Sessão expirada ou inválida.');
                    navigate("/login");
                }
            }).finally(() => setLoading(false));
            return;
        }

        // CASO MFA (Microsoft)
        if (code && state) {
            AuthRUService.completeMfa({ code, state }).then(success => {
                if (success) {
                    navigate("/", { replace: true });
                } else {
                    toast.error('Erro ao concluir autenticação MFA.');
                    navigate("/login");
                }
            }).catch(() => {
                toast.error('Erro inesperado na autenticação.');
                navigate("/login");
            }).finally(() => setLoading(false));
            return;
        }

        // ACESSO INDEVIDO
        setLoading(false);
        navigate("/login");
    }, [navigate, location]);

    return (
        <>
            {Loading}
            <div className="text-center" style={{ padding: '100px 0', height: '100vh', backgroundColor: '#fff' }}>
                <div className="fa fa-spinner fa-spin fa-3x mb-4" style={{ color: '#f37021' }}></div>
                <h3>Sincronizando sua conta...</h3>
                <p>Aguarde enquanto preparamos seu acesso seguro.</p>
            </div>
        </>
    );
};

export default AuthCallback;